export const RELEASE_DETAILS_FULL_NAME_INPUT_NAME = 'patient-full-name'
export const RELEASE_DETAILS_DOB_INPUT_NAME = 'patient-dob'
export const RELEASE_DETAILS_SSN_SUFFIX_INPUT_NAME = 'patient-ssn-suffix'
export const RELEASE_DETAILS_ADDRESS_LINE1_INPUT_NAME = 'patient-address-line1'
export const RELEASE_DETAILS_CITY_INPUT_NAME = 'patient-city'
export const RELEASE_DETAILS_STATE_INPUT_NAME = 'patient-state'
export const RELEASE_DETAILS_COUNTRY_INPUT_NAME = 'patient-country'
export const RELEASE_DETAILS_ZIP_CODE_INPUT_NAME = 'patient-zip-code'
export const RELEASE_FORM_PATIENT_SIGNATURE_INPUT_NAME = 'patient-signature'
export const RELEASE_FORM_GOOGLE_AUTOCOMPLETE_INPUT_NAME = 'google-place'
